module.exports = __webpack_public_path__ + "static/media/home.bada5963.svg";